import { ReferenceField, FunctionField, useRecordContext } from 'react-admin';
import { Box } from '@mui/material';
import { EventType, Event } from '../../types';
import BedMeshHeightMap from './BedMeshHeightMap';

const BedMeshCalibrationContent = ({
  eventType,
  record,
}: {
  record?: Event;
  eventType: EventType;
}) => {
  if (!record?.rawContent) return null;
  if (eventType.name !== 'bed-mesh-calibration') return null;

  try {
    const rawData = JSON.parse(record.rawContent);
    const calibration = rawData?.fields?.output;

    if (!calibration) return null;

    return (
      <Box sx={{ p: 2 }}>
        <BedMeshHeightMap calibration={calibration} />
      </Box>
    );
  } catch {
    // Error parsing rawContent, silently ignore
    return null;
  }
};

export const BedMeshCalibration = () => {
  const record = useRecordContext<Event>();
  return (
    <ReferenceField source="eventTypeId" reference="event-types" link={false}>
      <FunctionField
        render={(eventType: EventType) => (
          <BedMeshCalibrationContent record={record} eventType={eventType} />
        )}
      />
    </ReferenceField>
  );
};
